import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import styles from './style.scss';
import { Alert } from '../../common/icons';

@inject('translationsStore') @observer

export default class UnauthorizedIPError extends Component {

    render() {
        return (
            <div className='login-form'>
                <div className='general-form-wrapper login'>
                    <div className='errorDiv' >
                        <span style={{ color: 'red' }}>
                            <Alert />{' '}
                            <span>{this.props.translationsStore.translate('UNAUTHORISEDIP_MESSAGE')}</span>
                        </span>
                        <div>{this.props.translationsStore.translate('UNAUTHORISEDIP_DESC')}</div>
                    </div>
                </div>
            </div>
        );

    }
}